import ProductSearchCellHtml from './product-search.cell.html'

export function ProductSearchCellDirective () {
  return {
    controller: 'ProductSearchCellCtrl',
    restrict: 'E',
    templateUrl: ProductSearchCellHtml,
  }
}
